export const environment = {
    production: false,
    apiURL: 'https://api-qa.day1cloud.com/api',
    // apiURL: 'http://localhost:4400/api',
    oauth: {
        clientId: 'MyProfile',
        issuer: 'https://risk-detection-router-api-qa-ct5ogq.rajrd4-1.usa-e1.cloudhub.io/ext/oauth2/'
    }    
}